import React from "react";
import { parseEventProperties } from "../../../helpers/analyticsPlus";

export const EventProperties: React.FC<{ propertiesJson: string }> = ({
  propertiesJson,
}) => {
  const props = parseEventProperties(propertiesJson);
  const entries = Object.entries(props);
  if (entries.length === 0) {
    return <div className="text-xs text-gray-400 italic">No properties</div>;
  }
  return (
    <dl className="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 text-xs">
      {entries.map(([key, value]) => (
        <React.Fragment key={key}>
          <dt className="text-gray-400 font-mono">{key}</dt>
          <dd className="text-gray-700 break-all">
            {typeof value === "object" ? JSON.stringify(value) : String(value)}
          </dd>
        </React.Fragment>
      ))}
    </dl>
  );
};
